import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const cols = [
  { title: "Services", links: [["Permanent Recruitment", "/services/permanent-recruitment"], ["Contract Staffing", "/services/contract-staffing"], ["Hospitality Staffing", "/services/hospitality-staffing"], ["HR Consultancy", "/services/hr-consultancy"], ["All Services", "/services"]] },
  { title: "Company", links: [["About Us", "/about"], ["For Employers", "/for-employers"], ["For Job Seekers", "/for-job-seekers"], ["Industries", "/industries"], ["Blog", "/blog"]] },
  { title: "Careers", links: [["Browse Jobs", "/jobs"], ["Submit Resume", "/submit-resume"], ["Register", "/candidate-registration"], ["Locations", "/locations"], ["Contact", "/contact"]] },
];

const legal = [["Privacy Policy", "/privacy-policy"], ["Terms & Conditions", "/terms"], ["Disclaimer", "/disclaimer"], ["Cookie Policy", "/cookie-policy"]];

export default function Footer() {
  const { settings } = useSite();
  const socials = [
    [settings.facebook, Facebook], [settings.instagram, Instagram],
    [settings.linkedin, Linkedin], [settings.twitter, Twitter],
  ].filter(([u]) => u);
  return (
    <footer data-testid="site-footer" className="relative mt-24 border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img src={settings.logo_url || "/logo.png"} alt="Dreamzz HR & Consultancy" className="h-14 w-auto" />
            </div>
            <p className="text-slate-400 text-sm max-w-sm leading-relaxed">
              {settings.company_name}. Professional manpower recruitment, staffing and HR solutions across Karnataka. Connecting the right talent with the right opportunity.
            </p>
            <div className="mt-5 space-y-2 text-sm text-slate-400">
              <a href={`tel:${settings.phone}`} className="flex items-center gap-2 hover:text-brand-emerald" data-testid="footer-phone"><Phone size={15} />{settings.phone}</a>
              <a href={`mailto:${settings.email}`} className="flex items-center gap-2 hover:text-brand-emerald" data-testid="footer-email"><Mail size={15} />{settings.email}</a>
              <span className="flex items-center gap-2"><MapPin size={15} />{settings.address}</span>
            </div>
            {socials.length > 0 && (
              <div className="flex gap-3 mt-5">
                {socials.map(([u, Icon], i) => (
                  <a key={i} href={u} target="_blank" rel="noreferrer" className="p-2 rounded-lg glass hover:text-brand-emerald">
                    <Icon size={18} />
                  </a>
                ))}
              </div>
            )}
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wider text-slate-300">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-sm text-slate-400 hover:text-brand-emerald transition-colors">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} {settings.company_name}. All rights reserved.</p>
          <div className="flex flex-wrap gap-4">
            {legal.map(([label, to]) => (
              <Link key={to} to={to} className="text-xs text-slate-500 hover:text-brand-emerald">{label}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
